module.exports = __webpack_public_path__ + "img/cooperation_2.453a3f25.png";